export const getRequiredOptionsFromStructure = (structure: any[]) => {
  const requiredOptions: string[] = [];

  structure?.forEach((section) => {
    section?.fields?.forEach((field: any) => {
      if (field.resourceName) {
        requiredOptions.push(field.resourceName);
      }
    });
  });

  return requiredOptions;
};

export const parsePayload = (structure: any[], data: any) => {
  const payload: Record<string, any> = {};
  structure?.forEach((section) => {
    section?.fields?.forEach((field: any) => {
      if (['select'].includes(field?.component)) {
        payload[field.name] = data[field.name].value;
      } else {
        payload[field.name] = data[field.name];
      }
    });
  });

  return payload;
};

export const getFileName = (
  reportName: string,
  fileNameFormat?: string,
  data?: any,
) => {
  let fileName = fileNameFormat ? fileNameFormat : `${reportName}.xlsx`;
  fileName = fileName.replace('{{reportName}}', reportName);
  Object.entries(data || {}).forEach(([key, value]) => {
    fileName = fileName.replace(`{{${key}}}`, value as any);
  });
  return fileName;
};

export const getRawFileName = (fileName: string) =>
  fileName.replace(/\.[^/.]+$/, '');

export const getRawExtension = (fileName: string) =>
  fileName.split('.').pop()?.toLowerCase() || '';

export const getBlobType = (fileName: string) => {
  const extension = getRawExtension(fileName);

  const mimeTypes: Record<string, string> = {
    docx:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    doc: 'application/msword',
    pdf: 'application/pdf',
    txt: 'text/plain',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xls: 'application/vnd.ms-excel',
  };

  return mimeTypes[extension] || 'application/octet-stream';
};
